export function justify(str?: string | null) {
  if (!str) {
    return "";
  }

  return str
    .split(" ")
    .map((s) => `${s.slice(0, 1).toUpperCase()}${s.slice(1).toLowerCase()}`)
    .join(" ");
}
